/**
 * WordPress dependencies
 */
 import { addFilter } from '@wordpress/hooks';
 import { __ } from '@wordpress/i18n';
 import { registerBlockType } from '@wordpress/blocks';

 /**
  * Internal dependencies
  */
 import metadata from './block.json';
 import edit from './edit';
 import save from './save';

 /**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
 import './style.scss';

 const { name, title, description, usesContext } = metadata;
 export { metadata, name };
 

 export const settings = {
    apiVersion: 2,
    title: __('Logo bar', 'museuio-companion'),
    description: __('Responsive logo bar', 'museuio-companion'),
    icon: 'columns',
    edit,
    save,
    attributes: metadata.attributes,
    deprecated: [ ],
 };

const cfg = { ...metadata, ...settings };
const reg = registerBlockType( name, cfg );